import React, { MouseEvent, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import DrawerWrapper from '@components/ui/Drawer/drawer-wrapper'
import usePortal from '@lib/hooks/usePortal'
import clsx from 'clsx'
import s from './product-buy-banner.module.scss'

interface Props {
  visible?: boolean
  keyboard?: boolean
  disableBackdropClick?: boolean
  onClose?: () => void
  onContentClick?: (event: MouseEvent<HTMLElement>) => void
  wrapClassName?: string
}

const defaultProps = {
  wrapClassName: '',
  keyboard: true,
  disableBackdropClick: false,
}

type NativeAttrs = Omit<React.HTMLAttributes<any>, keyof Props>
export type DrawerProps = Props & NativeAttrs

const ProductBuyBannerComponent: React.FC<
  React.PropsWithChildren<DrawerProps>
> = ({
  visible: customVisible,
  keyboard,
  disableBackdropClick,
  onClose,
  onContentClick,
  wrapClassName,
  children,
  ...props
}: React.PropsWithChildren<DrawerProps> & typeof defaultProps) => {
  const portal = usePortal(
    'buy-banner',
    () => document.getElementById('sublime-main'),
    s['buy-banner-wrapper'],
  )
  const [visible, setVisible] = useState<boolean>(false)

  useEffect(() => {
    if (typeof customVisible === 'undefined') return
    setVisible(customVisible)
  }, [customVisible])

  if (!portal) return null
  return createPortal(
    <DrawerWrapper
      placement={'bottom'}
      visible={visible}
      className={clsx(wrapClassName, s['drawer-wrapper'])}
      {...props}
    >
      {children}
    </DrawerWrapper>,
    portal,
  )
}

ProductBuyBannerComponent.displayName = 'SublimeBuyBanner'
const BuyBanner = ProductBuyBannerComponent
export default BuyBanner
